import { motion } from "framer-motion";
import { ChevronLeft, Flame } from "lucide-react";
import { STATES } from "@/constants";

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

export const GeneratingScreen = ({
  selectedVibe,
  loadingStage,
  currentLoadingMessage,
  setAppState,
}) => {
  return (
    <motion.div
      key="generating"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="min-h-screen flex flex-col items-center justify-center p-6 relative"
      data-testid="generating-screen"
    >
      <button 
        onClick={() => setAppState(STATES.VIBE)}
        className="absolute top-6 left-6 w-10 h-10 rounded-full bg-white flex items-center justify-center border-2 border-[#264653]/10 hover:border-[#264653]/30"
        data-testid="generating-back-btn"
      >
        <ChevronLeft className="w-5 h-5 text-[#264653]" />
      </button>

      <div className="relative">
        <div className="w-24 h-24 bg-[#E76F51]/20 rounded-full flex items-center justify-center loading-pulse">
          <Flame className="w-12 h-12 text-[#E76F51]" />
        </div>
        <div className="absolute inset-0 border-4 border-[#E76F51] border-t-transparent rounded-full animate-spin" />
      </div>
      <h2 className="text-2xl font-bold text-[#264653] mt-8">{loadingStage || "Cooking up ideas..."}</h2>
      <p className="text-[#264653]/60 mt-2 text-center capitalize">{selectedVibe} recipes coming right up</p>
      
      {/* Progress stages indicator */}
      <div className="flex items-center gap-2 mt-8">
        <div className={`w-3 h-3 rounded-full transition-all ${loadingStage.includes("Analyzing") ? "bg-[#E76F51] animate-pulse" : (loadingStage.includes("Matching") || loadingStage.includes("Creating") || loadingStage.includes("Generating") || loadingStage.includes("plating")) ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-6 h-0.5 transition-all ${loadingStage.includes("Matching") || loadingStage.includes("Creating") || loadingStage.includes("Generating") || loadingStage.includes("plating") ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-3 h-3 rounded-full transition-all ${loadingStage.includes("Matching") ? "bg-[#E76F51] animate-pulse" : (loadingStage.includes("Creating") || loadingStage.includes("Generating") || loadingStage.includes("plating")) ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-6 h-0.5 transition-all ${loadingStage.includes("Creating") || loadingStage.includes("Generating") || loadingStage.includes("plating") ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-3 h-3 rounded-full transition-all ${loadingStage.includes("Creating") && !loadingStage.includes("Generating") ? "bg-[#E76F51] animate-pulse" : (loadingStage.includes("Generating") || loadingStage.includes("plating")) ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-6 h-0.5 transition-all ${loadingStage.includes("Generating") || loadingStage.includes("plating") ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-3 h-3 rounded-full transition-all ${loadingStage.includes("Generating") ? "bg-[#E76F51] animate-pulse" : loadingStage.includes("plating") ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-6 h-0.5 transition-all ${loadingStage.includes("plating") ? "bg-[#2A9D8F]" : "bg-[#264653]/20"}`} />
        <div className={`w-3 h-3 rounded-full transition-all ${loadingStage.includes("plating") ? "bg-[#E76F51] animate-pulse" : "bg-[#264653]/20"}`} />
      </div>
      <div className="flex justify-between w-full max-w-xs mt-2 text-xs text-[#264653]/50">
        <span>Vibe</span>
        <span>Match</span>
        <span>Create</span>
        <span>Photos</span>
        <span>Plate</span>
      </div>

      <p className="text-sm text-[#264653]/40 mt-4">This usually takes 30-60 seconds</p>

      {currentLoadingMessage && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="mt-6 p-5 bg-gradient-to-r from-[#E76F51]/15 to-[#FFB703]/15 rounded-xl border border-[#E76F51]/30 shadow-sm"
        >
          <p className="text-lg font-semibold text-[#E76F51] mb-2">
            {currentLoadingMessage.verb}
          </p>
          <p className="text-base text-[#264653] leading-relaxed">
            <span className="font-bold text-[#2A9D8F]">Did you know?</span> {currentLoadingMessage.fact}
          </p>
        </motion.div>
      )}

      <button 
        onClick={() => setAppState(STATES.VIBE)}
        className="mt-8 text-sm text-[#264653]/50 hover:text-[#264653]"
      >
        Cancel
      </button>
    </motion.div>
  );
};
